export default (object, ...props) => props.reduce((obj, prop) => {
    if (obj) {
        const value = obj[prop]
        if (value) {
            return value
        }
    }
    return null
}, object)
